import React from 'react';
import image1 from '../../../../../../assets/image/home_carousel-2.svg';
import image2 from '../../../../../../assets/image/empty-state-5.png';
import styles from './EmptyState.module.scss';

type EmptyStateProps = {
  type?: 'NO_DATA' | 'PENDING';
};

export const EmptyState = ({ type = 'NO_DATA' }: EmptyStateProps) => {
  return (
    <div className={styles.container}>
      {type === 'NO_DATA' ? (
        <>
          <h5 className={styles.title}>Configure sua Análise de Cobertura</h5>
          <p className={styles.subtitle}>Se você for o administrador da conta, configure a análise de cobertura no Modo Administrador.</p>
          <p className={styles.subtitle}>Caso não seja, entre em contato com o administrador para concluir o processo.</p>
          <img src={image1} alt="" />
        </>
      ) : (
        <>
          <h5 className={styles.title}>Em breve sua Análise de Cobertura estará disponível.</h5>
          <p className={styles.subtitle}>Em poucos minutos, você poderá acessá-la com todas as informações atualizadas.</p>
          <img src={image2} alt="" />
        </>
      )}
    </div>
  );
};
